import { useLanguage } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";

export default function Impressum() {
  const { t } = useLanguage();
  const { content } = useContent();
  const imp = content.impressum || {};
  useSeo("Impressum", "Mentions légales", "Impressum von Our Promise Events.", "Mentions légales d'Our Promise Events.");

  return (
    <div data-testid="impressum-page">
      <PageHero title={t("legal.imprintTitle")} />
      <section className="bg-cream py-20 px-6">
        <div className="max-w-2xl mx-auto space-y-8 text-ink/85">
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-gold mb-3">{t("legal.responsible")}</p>
            <p className="font-heading text-2xl">{imp.company || "Our Promise Events"}</p>
            <p>{imp.name}</p>
            <p>{imp.street}</p>
            <p>{imp.zip_city}</p>
            <p>{imp.country}</p>
          </div>
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-gold mb-3">{t("legal.contact")}</p>
            <p><a className="elegant-link" href={`mailto:${imp.email}`}>{imp.email}</a></p>
            <p><a className="elegant-link" href={`tel:${(imp.phone || "").replace(/\s/g, "")}`}>{imp.phone}</a></p>
            {imp.uid && <p>UID: {imp.uid}</p>}
          </div>
        </div>
      </section>
    </div>
  );
}
